export const DisplayTaskActionType ={
    DISPLAY_TEXT: 0,
    DISPLAY_TEXT_SCROLLING: 1
}    
export const DisplayTaskActionTypeName = {
    [DisplayTaskActionType.DISPLAY_TEXT]: "Static",
    [DisplayTaskActionType.DISPLAY_TEXT_SCROLLING]: "Scrolling"
};
 